import { render } from "./MOverlayLoader.vue?vue&type=template&id=7f47a0fb&scoped=true"
import script from "./MOverlayLoader.vue?vue&type=script&lang=js"
export * from "./MOverlayLoader.vue?vue&type=script&lang=js"

import "./MOverlayLoader.vue?vue&type=style&index=0&id=7f47a0fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f47a0fb"]])

export default __exports__